export const LIST = "DEPOSIT_LISTING";
export const DROPDOWN = "DEPOSIT_DROPDOWN";
export const DETAILS = "DEPOSIT_DETAILS";
export const UPDATE = "DEPOSIT_UPDATE";
export const SYSALERT = "DEPOSIT_SYSALERT";
